import * as React from 'react'
import {observer} from 'mobx-react'
import {filter} from 'lodash'
import {useStores} from '../../../../lib/MobXProvider'
import {WidgetApi} from '../../../../lib/WidgetApi'
import {IconPerson} from '../../../ui/Icons'

///////////////////////////////////////////////////////////////////////////////

export const SubscriptionInfoCustomerDetails = observer(() => {
  const {api} = useStores<{api: WidgetApi}>()
  const {subscriptionInfo, customerInfo} = api

  if (!subscriptionInfo || !customerInfo) {
    return null
  }

  const salutation = customerInfo.stored_customer_salutation
  const firstName = customerInfo.stored_customer_firstname
  const lastName = customerInfo.stored_customer_lastname
  const email = customerInfo.stored_customer_email
  let salutationLabel = api.trans(`payment_form.salutations.${salutation}`, {
    defaultValue: salutation,
  })

  if (!salutation || salutation === 'none') {
    salutationLabel = null
  }

  const name = filter([salutationLabel, firstName, lastName], (v) => !!v).join(
    ' ',
  )

  return (
    <section className="customer-details">
      <div className="header">
        <div className="title">
          <h2 className="text">
            {api.trans('blocks.subscription_info.customer_details.title')}
          </h2>
          <span className="icon" role="presentation">
            <IconPerson />
          </span>
        </div>
      </div>

      <p className="main">
        {name && <span className="name">{name}</span>}
        {email && <span className="email">{email}</span>}
      </p>
    </section>
  )
})
